const pt = {
  AuthTitle: {
    Greetings: "Bem-vindo ao",
  },
  Auth: {
    EnterEmail: "Insira o email",
    EnterPassword: "Insira a senha",
    AgreeWith: "Eu concordo com",
    ProcessingPersonalData: "processamento de dados pessoais",
    UserAgreement: "contrato do usuário",
    EmailRequiredError: "Email é obrigatório",
    EmailWrongFormatError: "Formato de email inválido!",
    PasswordRequiredError: "Senha é obrigatória",
    ForgotPassword: "Esqueci minha senha",
  },
  Login: {
    Title: "Autenticação",
    Subtitle: "Preencha os campos abaixo para acessar sua conta.",
    Login: "Entrar",
    Register: "Cadastrar",
    LoginError: "Email ou senha incorretos",
    BuyTeacherLessons: "Comprar aulas com um professor",
  },
  Register: {
    Title: "Cadastro",
    Subtitle: "Preencha os campos abaixo para criar sua conta.",
    Register: "Cadastrar",
    Login: "Entrar",
    EnterLastName: "Insira o sobrenome",
    EnterFirstName: "Insira o nome",
    EnterEmail: "Insira o email",
    EnterGender: "Gênero",
    EnterBirthday: "Data de nascimento",
    EnterProfileCountryId: "Nacionalidade",
    EnterProfileCityId: "Cidade de residência",
    EnterProfileDegreeId: "Formação acadêmica",
    EnterPassword: "Insira a senha",
    RepeatPassword: "Repita a senha",
    LastNameRequiredError: "Sobrenome é obrigatório",
    LastNameMinLengthError: "Mínimo de 2 caracteres",
    FirstNameRequiredError: "Nome é obrigatório",
    FirstNameMinLengthError: "Mínimo de 2 caracteres",
    PhoneRequiredError: "Telefone é obrigatório",
    PhoneInvalidError: "Formato de telefone inválido",
    GenderRequiredError: "Gênero é obrigatório",
    BirthdayRequiredError: "Data de nascimento é obrigatória",
    ProfileCountryIdRequiredError: "Nacionalidade é obrigatória",
    ProfileCityIdRequiredError: "Cidade de residência é obrigatória",
    ProfileDegreeIdRequiredError: "Formação acadêmica é obrigatória",
    PasswordMismatchError: "As senhas não coincidem",
    PasswordMinLengthError: "Mínimo de 6 caracteres",
  },
  Reset: {
    Title: "Redefinição de senha",
    Subtitle:
      'Digite o e-mail que você forneceu durante o cadastro e clique no botão "Recuperar".',
    Reset: "Restaurar",
    Login: "Entrada",
    Success:
      "Dentro de alguns minutos, você receberá um e-mail em <0>{{email}}</0> com instruções sobre como recuperar sua senha.",
  },
  CookieNotice: {
    Message:
      "Para melhorar o funcionamento do site e sua interação com os usuários, utilizamos cookies. Ao continuar navegando, você permite o uso de cookies. Você pode desativá-los nas configurações do seu navegador.",
    Agree: "Aceitar e não mostrar novamente",
  },
  MainPage: {
    Title: "Página inicial",
    TitleGreetings: "Bem-vindo ao",
    TitleGreetingsMiddle: "FALE",
    TitleGreetingsEnd: "RUSSO!",
    MyCourses: "Meus cursos",
    CourseContinue: "CONTINUAR",
    CourseCountStart: "Você tem acesso a",
    CourseCount_zero: "{{count}} cursos",
    CourseCount_one: "{{count}} curso",
    CourseCount_few: "{{count}} cursos",
    CourseCount_many: "{{count}} cursos",
    AllCourses: "Todos os cursos",
    MyLessons: "Minhas aulas",
    AllLessons: "todas as aulas",
    EmptyCourses: "Nenhum curso",
    EmptyLessons: "Nenhuma aula",
    BuyTeacherLessons: "Comprar aulas com um professor",
    BuyTeacherLessonsLink: "aqui",
    ForeignCardTooltip: "Para cartões emitidos fora da Federação Russa",
    NoActiveLicense: "Você não tem uma licença ativa.",
    GoIntoLesson: "Ir para aula",
    FinishedLessons: "Concluído",
    CanceledLessons: "CANCELADO",
  },
  CoursesPage: {
    Title: "Cursos",
    TitleGreetings: "Bem-vindo ao",
    MyCourses: "Meus cursos",
    CourseContinue: "CONTINUAR",
    EmptyCourses: "Nenhum curso",
    SearchPlaceholder: "Buscar por nome",
    LevelPlaceholder: "Nível",
    AllLevels: "Todos os níveis",
  },
  Menu: {
    Main: "Página inicial",
    Words: "Palavras",
    Courses: "Meus cursos",
    Lessons: "Aulas com professor",
    TeacherCorner: "Tarefas criativas",
    AdditionalCourses: "Cursos adicionais",
    UsefulLinks: "Links úteis",
    Notifications: "Notificações",
    Video: "Vídeo",
    TeacherGroups: "Grupos",
    TeacherAttendance: "Frequência",
    TeacherClasses: "Aulas",
    TeacherReports: "Relatórios",
    CreativeTasks: "Tarefas criativas",
    Attendance: "Frequência",
  },
  Footer: {
    Copyright: "Todos os direitos reservados",
    About: "Sobre a empresa",
    PrivacyPolicy: "Política de uso de dados",
    PrivacyProtect: "Regulamento de tratamento e proteção de dados pessoais",
  },
  Module: {
    exercise_one: "exercício",
    exercise_two: "exercícios",
    exercise_few: "exercícios",
    Completed: "Concluído",
    Result: "Resultado",
    InWork: "Em andamento",
    Done: "Finalizado",
  },
  SteppedProgress: {
    Completed: "Concluído",
  },
  CourseDetails: {
    Title: "Informações do curso",
    Progress: "Progresso",
    Completed: "CONCLUÍDO",
    Result: "RESULTADO",
    Hours: "Horas",
    Lessons: "Aulas",
    Units: "Módulos",
    Unit: "Módulo",
    Exercises_zero: "{{count}} exercícios",
    Exercises_one: "{{count}} exercício",
    Exercises_few: "{{count}} exercícios",
    Exercises_many: "{{count}} exercícios",
  },
  CourseUnitDetails: {
    Vocabulary: "Vocabulário",
    Video: "Vídeo",
    Grammar: "Gramática",
    Reading: "Leitura",
    Writting: "Escrita",
    Speaking: "Conversação",
    Test: "Teste",
    Unknown: "Desconhecido",
    EmptyExercises: "Nenhum exercício",
  },
  EntranceTest: {
    ModalTitle: "Avalie seu nível de conhecimento",
    ModalBody:
      "Faça o teste para determinar seu nível de russo. Duração média: 40 minutos.",
    Cancel: "Cancelar",
    Take: "Iniciar teste",
  },
  TeacherPage: {
    Title: "Área do professor",
    MyLessons: "Minhas aulas",
    MyModules: "Meus módulos",
  },
  DistributorPage: {
    Title: "Área do distribuidor",
  },
  CoordinatorPage: {
    Title: "Área do coordenador",
  },
  Distributor: {
    Report: "Relatórios",
    DateFrom: "De",
    DateTo: "Até",
    Status: "Status",
    StatusReady: "Pronto",
    StatusPlanned: "Processando",
    Actions: "Ações",
    FromRequiredError: "Selecione a data inicial",
    ToRequiredError: "Selecione a data final",
  },
  Button: { Send: "Enviar", Download: "Baixar" },
  LessonsTable: {
    GroupName: "Grupos",
    Status: "Status",
    StartDateTime: "Data e hora",
    Duration: "Horas/aula",
    Credentials: "Webinar: Login/Senha",
    CredentialsCopied: "Copiado!",
    SortAlpabetically: "Ordenar A-Z",
  },
  LessonStatuses: {
    completed: "Realizado",
    planned: "Agendado",
    earlyCanceledByCustomer: "Cancelado pelo aluno",
    earlyCanceledBySchool: "Cancelado pelo professor",
    lateCanceledByCustomer: "Cancelado pelo aluno",
    lateCanceledBySchool: "Cancelado pelo professor",
    notPerformedToPay: "A pagar",
  },
  LessonAttendance: {
    Status: "Selecione o status",
    Date: "Selecionar data",
    Time: "Selecionar horário",
    Duration: "Duração",
    AH: "h/a",
    Students: "Alunos",
    CheckAll: "Marcar todos",
    Comment: "Comentário",
    Submit: "Concluir",

    restrictiveBackDateError: "Data não pode ser anterior à permitida",
    restrictiveForwardDateError: "Data não pode ser posterior à permitida",
    commentSizeError: "Comentário deve ter menos de {{count}} palavras",
    requiredFieldError: "Campo obrigatório",
    requiredDateError: "Preencha data e hora",
    ExcessHoursWarning: "Excesso de horas",
    MarkStudents: "Marque os alunos presentes e salve as alterações.",

    apiError: "Erro ao salvar. Contate online@dschool.ru",
    early_cancel_by_customer_not_acceptable:
      "Cancelamento antecipado não permitido. Contate o coordenador.",
    early_cancel_by_school_not_acceptable:
      "Cancelamento antecipado não permitido. Contate o coordenador.",
  },
  TeacherReportsPage: {
    Title: "Relatórios",
    HeaderTitle: "Relatórios",
    CreateReport: "criar relatório",
  },
  TeacherReportTable: {
    Title: "Título do relatório",
    CreationDate: "Data de criação",
    Period: "Período",
    Status: "Status",
    StatusDone: "pronto",
    StatusPending: "processando",
    Actions: "Ações",
    Statistics: "Estatísticas da plataforma",
    CourseProgress: "Progresso do curso",
    ActiveTime: "Relatório de tempo na plataforma",
    EntranceTest: "Teste inicial",
    LecenseReport: "Relatório de licenças",
    HeaderTitle: "Relatórios",
    CreateReport: "Criar relatório",
    DeleteReport: "Confirmar exclusão?",
    DeleteTooltip: "Excluir",
    MailTooltip: "Enviar por email",
    DownloadTooltip: "Baixar",
    DeleteGroupTooltip: "Excluir selecionados",
    MailGroupTooltip: "Enviar selecionados por email",
    DownloadGroupTooltip: "Baixar selecionados",
  },
  CreateReportForm: {
    Statistics: "Estatísticas da plataforma",
    CourseProgress: "Progresso do curso",
    ActiveTime: "Relatório de tempo na plataforma",
    Report: "Meu relatório",
    Title: "Criar relatório",
    Type: "Tipo de relatório",
    TypeLabel: "Tipo",
    NameLabel: "Nome",
    DateLabel: "Data",
    DateFromLabel: "De",
    DateToLabel: "Até",
    Name: "Nome do relatório",
    Period: "Período",
    PeriodFrom: "De",
    PeriodTo: "Até",
    Date: "Data",
    FilterListGroup: "Grupo",
    FilterListStudent: "Aluno",
    FilterListCompany: "Empresa cliente",
    FilterListTest: "Nome do teste inicial",
    FilterListSelectedStudents: "Filtrar alunos ({{count}} selecionados)",
    FilterListSelectedGroups: "Filtrar grupos ({{count}} selecionados)",
    FilterListSelectedCompanies: "Filtrar empresas ({{count}} selecionadas)",
    FilterListSelectedTests: "Filtrar testes ({{count}} selecionados)",
    FilterListSelectedPlaceholderStudents: "Selecionar alunos",
    FilterListSelectedPlaceholderGroups: "Selecionar grupos",
    FilterListSelectedPlaceholderCompanies: "Selecionar empresas",
    FilterListSelectedPlaceholderTests: "Selecionar testes",
    GroupsChosen: "Grupos selecionados",
    ChooseAll: "Selecionar todos",
    RemoveAll: "Remover todos",
    GroupName: "Grupo",
    GroupDefault: "Agrupar por padrão",
    Cancel: "Cancelar",
    Create: "Criar",
    TitleRequiredError: "Título obrigatório",
    FromRequiredError: "Selecione a data inicial",
    ToRequiredError: "Selecione a data final",
    GroupsRequiredError: "Selecione ao menos um grupo!",
    OrderCreateError: "Falha ao criar relatório",
    FieldRequiredError: "Campo obrigatório",
    NoItems: "Nenhum grupo",
  },
  Gender: {
    Male: "Masculino",
    Female: "Feminino",
  },
  Role: {
    student: "Aluno",
    teacher: "Professor",
    distributor: "Distribuidor",
    coordinator: "Coordenador",
  },
  EmailNotConfirmed: {
    Title:
      "Enviamos um email de confirmação para {{email}}. Verifique sua caixa de entrada. Dúvidas? Contate online@dschool.ru",
    Back: "<< Voltar",
  },
  MyWordsPage: {
    Title: "Minhas palavras",
    EmptyWordList: "Nenhuma palavra para estudar. Altere os filtros.",
  },
  WordsFilter: {
    Title: "Filtros",
    Clear: "Limpar",
    EmptyCourses: "Nenhum curso disponível",
    ChooseCourse: "Selecione o curso",
    ChooseUnit: "Selecione o módulo",
    EmptyUnits: "Nenhum módulo disponível",
  },
  SetupPassword: {
    Title: "Definir senha",
    Subtitle: "Defina uma nova senha nos campos abaixo.",
  },
  SetupPasswordRedirect: {
    Title: "Ação necessária",
    Description: "Defina uma senha para continuar usando o serviço.",
    Redirect: "Definir senha",
  },
  ChangePassword: {
    Password: "Senha",
    PasswordRepeat: "Confirmar senha",
    Confirm: "Confirmar",
    PasswordShortError: "Senha deve ter mais de 6 caracteres",
    PasswordMismatch: "Senhas não coincidem",
    Success: "Senha alterada com sucesso",
    Login: "Ir para a página de autorização",
  },
  ProfilePage: {
    Title: "Meu perfil",
  },
  Profile: {
    PersonalData: "Dados pessoais",
    FirstName: "Nome",
    LastName: "Sobrenome",
    BirthDate: "Data de nascimento",
    Citizenship: "Nacionalidade",
    Degree: "Formação acadêmica",
    City: "Cidade de residência",
    NewPassword: "Nova senha",
    ConfirmNewPassword: "Confirmar nova senha",
    Password: "Senha",
    Save: "Salvar",
    DataUpdateSuccess: "Dados atualizados com sucesso",
    Settings: "Configurações",
    ShowPassingResults: "Exibir resultados de conclusão",
  },
  UsefulLinks: {
    Title: "Links úteis",
    GroupName: "Grupo:",
    Added: "Adicionado em",
    NoLinks: "Nenhum link",
  },
  DatePicker: {
    Today: "Hoje",
    Clear: "Limpar",
  },
  Promocode: {
    Expired: "Inscrições encerradas. Contate seu gerente.",
  },
  TeachersAutocompleteFilter: {
    EnterTeacherName: "Nenhum professor encontrado",
    SelectTeacher: "Selecionar professor",
  },
  Loading: {
    Error: "Erro ao carregar. Recarregue a página.",
  },
  MultipleSelect: {
    SelectAll: "Selecionar todos",
  },
  Attendance: {
    Title: "Frequência",
  },
};

export default pt;
